// extracted by mini-css-extract-plugin
module.exports = {"featureBox":"feature-module--featureBox--OCDnf","outterBox":"feature-module--outterBox--1N_jI"};